import React, { Fragment } from "react";
import DataTable from "react-data-table-component";
import DataTableExtensions from "react-data-table-component-extensions";
import moment from "moment";
import "react-toastify/dist/ReactToastify.css";
const Transactions = ({ myData, myClass }) => {
  let i = 0;
  const columnDefs = [
    {
      name: "S.No",
      selector: (row) => (i += 1),
      sortable: true,
    },
    {
      name: "Type",
      cell: (row) => (
        <span
          style={{
            color: row?.type?.toLowerCase() === "deposit" ? "green" : "red",
            fontWeight: "600",
          }}>
          {row?.type?.toLowerCase() === "deposit" ? "CREDITED" : "DEBITED"}
        </span>
      ),
      sortable: true,
    },
    {
      name: "Amount",
      cell: (row) => (
        <span
          style={{
            color: row?.type?.toLowerCase() === "deposit" ? "green" : "red",
            fontWeight: "600",
          }}>
         {row?.type?.toLowerCase() === "deposit" ? `+ €${row?.amount}` : `- €${row?.amount}`}
        </span>
      ),
      sortable: true,
    },
    {
      name: "Source",
      selector: (row) => row?.source?.toUpperCase(),
      sortable: true,
    },
    {
      name: "status",
      selector: (row) => row.status,
      sortable: true,
    },
    {
      name: "Date",
      selector: (row) => moment(row?.createdAt).format("DD/MM/YYYY HH:mm"),
      sortable: true,
    },
  ];

  return (
    <div>
      <Fragment>
        <DataTableExtensions
          columns={columnDefs}
          data={myData}
          print={false}
          export={false}>
          <DataTable
            data={myData}
            columns={columnDefs}
            className={myClass}
            pagination
            striped={true}
            center={true}
          />
        </DataTableExtensions>
      </Fragment>
    </div>
  );
};

export default Transactions;
